import has from 'has';
import featureCategories from 'effective-features!';
import _ from 'lodash';

var hasFeatureFn = function hasFeatureFn(featureCategory) {
    return featureCategory && featureCategory !== 'false';
};

for (var featureCategory in featureCategories) {
    if (featureCategories.hasOwnProperty(featureCategory)) {
        if (Array.isArray(featureCategories[featureCategory])) {
            for (var i = 0; i < featureCategories[featureCategory].length; i++) {
                if (!has.add(featureCategory + '.' + featureCategories[featureCategory][i])) {
                    has.add(featureCategory + '.' + featureCategories[featureCategory][i], hasFeatureFn.bind(undefined, featureCategories[featureCategory][i]));
                }
            }
        } else if (!has.add(featureCategory)) {
            has.add(featureCategory, hasFeatureFn.bind(undefined, featureCategories[featureCategory]));
        }
    }
}

function getAllFeatures() {
    return featureCategories;
}

function hasFeature(featureName) {
    return has(featureName);
}

function getFeatureEnabledStates(routesConfig) {
    return _.pick(routesConfig, function (route) {
        var featureToggler = route.featureToggler;

        return !featureToggler || hasFeature(featureToggler);
    });
}

/**
 * Service for setting up has feature check functions and returning feature categories
 */
export default {
    getAllFeatures: getAllFeatures,
    hasFeature: hasFeature,
    getFeatureEnabledStates: getFeatureEnabledStates
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-featuredetection-js/ApplicationFeatures.js
// module id = 17
// module chunks = 0